import axiosInstance from "../axiosInstance";

const CONTROLLER = "iaPlan";

const get_ia_plans = async (search, state) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}?search=${search || ""}&state=${state}`,
	);
	return response.data;
};

const get_ia_plan_by_id = async (id) => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetIAPlanById/${id}`);
	return response.data;
};

const get_ia_plans_header_info = async () => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetIAPlansHeader`);
	return response.data;
};

const update_ia_plan = async (id, data) => {
	const response = await axiosInstance.put(`${CONTROLLER}/${id}`, data, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return response.data;
};

const update_ia_plan_state = async (state) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/UpdateIAPlanStatus`,
		state,
	);
	return response.data;
};

const create_ia_plan = async (data) => {
	const response = await axiosInstance.post(`${CONTROLLER}`, data, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return response.data;
};

export {
	create_ia_plan,
	get_ia_plans,
	get_ia_plans_header_info,
	update_ia_plan_state,
	get_ia_plan_by_id,
	update_ia_plan,
};
